export default "__VITE_ASSET__DSnbNLtq__"